import FileResultModal from './FileResultModal';
import React from 'react';

class FileUploadResultModal extends React.Component<{
  open?: boolean;
  headerText: string;
  text: string;
  addedUsers?: number;
  notFoundUsers?: number;
  duplicatedUsers?: number;
  usersNotFoundList?: string[];
  downloadMessageText?: string;
  showSuccessMessageOnly: boolean;
  buttonText: string;
  buttonSize?: 'small' | 'medium' | 'large';
  handleButtonClick: () => void;
}> {
  render() {
    const {
      open,
      headerText,
      text,
      addedUsers,
      notFoundUsers,
      duplicatedUsers,
      usersNotFoundList,
      downloadMessageText,
      showSuccessMessageOnly,
      buttonText,
      buttonSize,
      handleButtonClick,
    } = this.props;
    const details = [
      { text: `Users were added: ${addedUsers?.toString()}` },
      { text: `Users were not found: ${notFoundUsers?.toString()}` },
      { text: `Duplicates: ${duplicatedUsers?.toString()}` },
      { text: '', usersNotFoundList },
    ];

    return (
      <FileResultModal
        open={open}
        headerText={headerText}
        text={text}
        details={details}
        downloadMessageText={downloadMessageText}
        showSuccessMessageOnly={showSuccessMessageOnly}
        buttonText={buttonText}
        buttonSize={buttonSize}
        handleButtonClick={handleButtonClick}
      />
    );
  }
}

export default FileUploadResultModal;
